<script setup lang="ts">
import type { TextWithImageData } from 'types/blocks';
import type { ComponentStyles } from 'types/index';

const layout = useLayout();

defineProps<{
  data: TextWithImageData;
  componentStyles: ComponentStyles;
}>();
</script>

<template>
  <BaseComponentWrapper
    v-if="data"
    :component-styles="componentStyles"
  >
    <article class="container grid grid-cols-1 gap-y-8 lg:grid-cols-2 lg:gap-24">
      <div
        class="flex w-full items-center"
        :class="{ 'order-last': data.reverse && layout.isDesktop }"
      >
        <div>
          <BaseRte
            v-if="data.text"
            :content="data.text"
          />

          <BaseButton
            v-if="data.cta"
            class="mt-6 md:mt-12"
            :to="data.cta.url"
            :title="data.cta.name"
            :target="data.cta.target"
          >
            {{ data.cta.name }}
          </BaseButton>
        </div>
      </div>

      <div class="flex w-full items-center overflow-hidden">
        <HumbleScroll
          animation="fade"
          class="size-full"
          inner-class="size-full"
        >
          <figure
            v-if="data.image?.url"
            class="size-full"
          >
            <BaseImage
              :image="data.image"
              class="size-full object-cover md:max-h-textWImage"
              sizes="100vw lg:50vw"
            />
          </figure>
        </HumbleScroll>
      </div>
    </article>
  </BaseComponentWrapper>
</template>
